import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { ClipLoader } from 'react-spinners';

const TileGroup = ({
    name,
    value,
    options,
    onChange,
    error,
    loading = false,
    columns = 2,
}) => {
    const handleSelect = (optionValue, disabled) => {
        if (disabled) return;
        onChange(null, { name, value: optionValue });
    };

    const gridColsClass =
        columns === 4 ? 'sm:grid-cols-4' :
        columns === 3 ? 'sm:grid-cols-3' :
        'sm:grid-cols-2';

    return (
        <div className="relative">
            <div
                role="radiogroup"
                aria-label={name}
                className={`grid grid-cols-1 ${gridColsClass} gap-3`}
            >
                {(options || []).map((opt) => {
                    const selected = value === opt.value;
                    const disabled = opt.disabled === true;
                    return (
                        <button
                            type="button"
                            key={opt.key ?? opt.value}
                            role="radio"
                            aria-checked={selected}
                            aria-disabled={disabled}
                            disabled={disabled}
                            onClick={() => handleSelect(opt.value, disabled)}
                            className={[
                                'relative flex items-center gap-3 rounded-xl border p-4 text-left transition-all',
                                disabled
                                    ? 'cursor-not-allowed border-border bg-surface-muted opacity-60'
                                    : selected
                                        ? 'border-indigo-500 bg-indigo-50 dark:bg-indigo-500/10 shadow-sm'
                                        : 'border-border bg-surface hover:border-border-strong hover:shadow-sm',
                            ].join(' ')}
                        >
                            {opt.icon && (
                                <span
                                    className={`flex-shrink-0 ${selected ? 'text-indigo-600 dark:text-indigo-400' : 'text-foreground-secondary'}`}
                                    style={{ fontSize: '24px', lineHeight: 1 }}
                                >
                                    {opt.icon}
                                </span>
                            )}
                            <span className="flex-1 min-w-0">
                                <span className={`block text-sm font-medium ${selected ? 'text-indigo-900 dark:text-indigo-200' : 'text-foreground'}`}>
                                    {opt.text}
                                </span>
                                {opt.description && (
                                    <span className="block text-xs text-foreground-muted mt-0.5">
                                        {opt.description}
                                    </span>
                                )}
                            </span>
                            {selected && (
                                <CheckCircleIcon className="h-5 w-5 text-indigo-500 dark:text-indigo-400 flex-shrink-0" />
                            )}
                        </button>
                    );
                })}
            </div>
            {error && <p className="text-sm mt-1 text-text-error">{error}</p>}
            {loading && (
                <div className="absolute right-3 top-1/2 -translate-y-1/2 z-50 pointer-events-none bg-surface">
                    <ClipLoader color="#6366f1" size={18} />
                </div>
            )}
        </div>
    );
};

export default TileGroup;
